import { p } from '@/utils/content-blocks';

export const INSTALL_STEPS = [
	{
		step: 1,
		title: 'Enable Unknown Sources',
		text: 'Open Settings → Security (or Apps) → Install unknown apps → allow your browser or Files app. On Samsung, toggle per app—not a global switch.',
	},
	{
		step: 2,
		title: 'Download the APK',
		text: 'On gbwaps.com, open the download page, tap the green button, and wait until ~82 MB finishes. Note the version 18.80 tag before you open the file.',
	},
	{
		step: 3,
		title: 'Install the APK',
		text: 'Tap the file in Downloads, confirm installer shows 18.80, then press Install. If you see “App not installed”, see the errors section below—do not uninstall official WhatsApp unless you backed up.',
	},
	{
		step: 4,
		title: 'Verify Your Number',
		text: 'Enter country code and phone number, wait for SMS OTP, and complete verification. Keep date/time on automatic—wrong clock breaks “verifying” loops.',
	},
	{
		step: 5,
		title: 'Restore Backup (Optional)',
		text: 'If you used WhatsApp before, tap Restore when prompted. Local or Google Drive backups from official WhatsApp usually work when signatures and CPU arch match.',
	},
];

export const INSTALL_HOWTO_SCHEMA = {
	'@context': 'https://schema.org',
	'@type': 'HowTo',
	name: 'How to Install GB WhatsApp on Android',
	description:
		'Step-by-step guide to install GB WhatsApp APK on Android: enable unknown sources, download, install, verify, and restore chats.',
	step: INSTALL_STEPS.map((s) => ({
		'@type': 'HowToStep',
		position: s.step,
		name: s.title,
		text: s.text,
	})),
};

export const INSTALL_SECTIONS = [
	{
		id: 'install-overview',
		h2: 'How to Install GB WhatsApp APK on Android',
		blocks: [
			p([
				{ text: 'You install ' },
				{ link: { to: '/', text: 'GB WhatsApp' } },
				{
					text: ' like any sideloaded APK—no Play Store. The whole flow takes a few minutes if unknown sources are already allowed. Grab the file from ',
				},
				{ link: { to: '/download/', text: 'Download GB WhatsApp APK' } },
				{ text: ' first, then follow the numbered steps on this page.' },
			]),
			p([
				{
					text: 'Charge above 20%, use stable Wi‑Fi for the download, and back up chats if you migrate from official WhatsApp. Interrupted installs corrupt packages—especially on MIUI and ColorOS phones with aggressive battery savers.',
				},
			]),
		],
	},
	{
		id: 'unknown-sources',
		h2: 'Enable Unknown Sources on Device',
		blocks: [
			p([
				{
					text: 'Android blocks APKs from outside Play Protect until you whitelist the app that opens the file. For Chrome downloads: Settings → Apps → Chrome → Install unknown apps → Allow. For Files: do the same under Files or “My Files”.',
				},
			]),
			p([
				{
					text: 'Android 13+ uses per-app toggles—there is no single “unknown sources” master switch anymore. If the installer never appears, you almost always forgot this step for the app you used to open the APK.',
				},
			]),
		],
	},
	{
		id: 'step-process',
		h2: 'Step-by-Step Installation Process',
		layout: 'steps',
		blocks: [
			p([
				{
					text: 'Work through the five steps below in order. Screenshots show a typical Android 12+ layout; menus vary slightly by brand.',
				},
			]),
		],
	},
	{
		id: 'first-setup',
		h2: 'First Setup After Installation',
		blocks: [
			p([
				{
					text: 'After OTP, add your display name and photo like stock WhatsApp. Open GB Settings (or ⋮ menu) to explore privacy and theme toggles—enable one feature at a time during the first 48 hours to reduce ban risk.',
				},
			]),
			p([
				{
					text: 'Confirm About shows 18.80. If login loops, sync time zone, switch Wi‑Fi, or re-download from the download page. Do not clear data until you try a fresh APK with matching size.',
				},
			]),
		],
	},
	{
		id: 'errors-fixes',
		h2: 'Installation GB WhatsApp Errors and Fixes',
		blocks: [
			p([
				{
					text: '“App not installed” — signature clash with another mod, corrupt download, or low storage. Delete partial installs, free space, re-download 82 MB / 18.80, try again.',
				},
			]),
			p([
				{
					text: '“There was a problem parsing the package” — incomplete download or wrong architecture. Re-fetch the APK; x86 tablets need an x86 build if the developer ships one.',
				},
			]),
			p([
				{ text: 'Still stuck? Use ' },
				{ link: { to: '/troubleshooting/', text: 'GB WhatsApp Troubleshooting' } },
				{ text: ' for ordered fixes before factory reset.' },
			]),
		],
	},
	{
		id: 'permissions',
		h2: 'Permissions Required for GB WhatsApp',
		blocks: [
			p([
				{
					text: 'Expect contacts, storage, camera, microphone, and phone permissions—same family as official WhatsApp. Denying storage breaks media backup; denying phone/SMS blocks OTP.',
				},
			]),
			p([
				{
					text: 'Review permissions after updates. Shady repacks sometimes ask for SMS admin or accessibility without a clear reason—abort install if the list looks unrelated to messaging.',
				},
			]),
		],
	},
	{
		id: 'common-issues',
		h2: 'Common Installation Issues',
		blocks: [
			p([
				{
					text: 'Installer opens then disappears — battery saver killed the package installer. Whitelist Package Installer / MIUI Installer in battery settings.',
				},
			]),
			p([
				{
					text: 'Two mods conflict — only one GB-style client per signature usually installs. Remove the old mod APK, keep official WhatsApp if you need both numbers on different apps.',
				},
			]),
			p([
				{
					text: 'Play Protect block — tap Install anyway if size and host match gbwaps.com. If Protect insists after that, scan with another AV but compare file metadata first.',
				},
			]),
		],
	},
];
